import React from "react";
import { Plus, ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./ProductsCatalog.scss";
import { photoVariant } from "../../../../utils/imageUrl";

export default function ProductsCatalog({ products = [], onAddProduct, ownerId }) {
  const navigate = useNavigate();

  // Hidden items are only actionable from the full management list
  // (/profile/:id/products) — this is just a quick teaser rail, so keep it
  // limited to what's actually visible right now.
  const visibleProducts = Array.isArray(products)
    ? products.filter((p) => (p.status || "active") !== "hidden")
    : [];
  const hasProducts = visibleProducts.length > 0;
  const previewProducts = hasProducts ? visibleProducts.slice(0, 5) : [];

  const openAllProducts = () => {
    if (ownerId) {
      navigate(`/profile/${encodeURIComponent(ownerId)}/products`);
      return;
    }

    navigate("/business/products");
  };

  return (
    <div className="bpProductsCatalog">
      {!hasProducts ? (
        <div className="bpProductsCatalog__empty">
          <div className="bpProductsCatalog__emptyIcon">
            <ShoppingBag size={30} strokeWidth={2.4} />
          </div>

          <strong>Каталог товарів порожній</strong>

          <p>Додай перший товар, щоб він зʼявився у бізнес-профілі.</p>

          <button type="button" onClick={onAddProduct}>
            <Plus size={19} strokeWidth={2.8} />
            Додати товар
          </button>
        </div>
      ) : (
        <>
          <div className="bpProductsCatalog__top">
            <div>
              <strong>{products.length} товарів</strong>
              <span>Перші товари у превʼю блоку</span>
            </div>

            <button type="button" onClick={openAllProducts}>
              Всі товари
            </button>
          </div>

          <div className="bpProductsCatalog__rail">
            {previewProducts.map((item) => (
              <article
                key={item.listingId || item.id}
                className="bpProductCard"
                onClick={() => navigate(`/listing/${item.listingId}`)}
              >
                <div className="bpProductCard__image">
                  {item.mainPhoto || item.photos?.[0] ? (
                    <img src={photoVariant(item.mainPhoto || item.photos?.[0], "sm")} alt="" loading="lazy" decoding="async" />
                  ) : (
                    <span>{String(item.title || "T").slice(0, 1).toUpperCase()}</span>
                  )}
                </div>

                <div className="bpProductCard__body">
                  <strong>{item.title || "Новий товар"}</strong>

                  <em>
                    {item.availability === "preorder"
                      ? "Під замовлення"
                      : item.availability === "out_of_stock"
                      ? "Немає в наявності"
                      : "В наявності"}
                  </em>

                  <div>
                    <b>
                      {Number(item.price || 0) > 0
                        ? `${item.price} ${item.currency || "ГРН"}`
                        : "Ціну уточнюйте"}
                    </b>

                    <button type="button">Відкрити</button>
                  </div>
                </div>
              </article>
            ))}

            <button type="button" className="bpProductAddCard" onClick={onAddProduct}>
              <span>
                <Plus size={23} strokeWidth={2.8} />
              </span>
              <strong>Додати товар</strong>
              <em>Фото, назва, ціна</em>
            </button>
          </div>
        </>
      )}
    </div>
  );
}